//NEW STYPEPARAMS METHOD
var VIDEO_PLAY_TRIGGER = {
    HOVER: 'HOVER',
    AUTO: 'AUTO',
    CLICK: 'CLICK',
};
export default VIDEO_PLAY_TRIGGER;
//# sourceMappingURL=behaviourParams_item_video_playTrigger.js.map